export const fireMapping: any = {
  Atomic: {
      color: 'red',
      scale: 5,
  },
  BBQ: {
      color: 'orange',
      scale: 2,
  },
  Cajun: {
      color: 'green',
      scale: 1,
  },
  Default: {
      color: 'gray',
      scale: 5,
  },
  GarlicParm: {
      color: 'orange',
      scale: 3,
  },
  Hawaiian: {
      color: 'orange',
      scale: 3,
  },
  LemonPepper: {
      color: 'orange',
      scale: 2,
  },
  LouisianaRub: {
      color: 'orange',
      scale: 2,
  },
  MangoHabanero: {
      color: 'red',
      scale: 4,
  },
  MildGreen: {
      color: 'red',
      scale: 4,
  },
  OriginalHot: {
      color: 'green',
      scale: 1,
  },
  SKQ: {
      color: 'green',
      scale: 1,
  },
};
